export default function Toast({ message }) {
  return (
    <div className="toast">
      <span className="toast-check">✓</span>
      {message}
    </div>
  );
}
